import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap'
import { Plus, Trash } from 'react-feather'

import { addCollectionRegister, removeCollectionRegister } from '../../../redux/actions/form'

import Repeater from '../repeater'
import { CardInterpreter } from './CardInterpreter'
import { useCollection } from '../../../utility/hooks/useCollection'

export const RepeaterInterpreter = ({ collection, card, exceptions, internalStructure = {} }) => {
    const dispatch = useDispatch()
    const form = useSelector(state => state.form)
    const repeterData = useCollection().getCollectionNode(form, collection, false, false)
    const count = repeterData?.length || 0

    const increaseCount = () => dispatch(addCollectionRegister(collection, null, { main: !(count), ...internalStructure }))

    return (
        <>
            <Repeater count={count}>
                {i => <div className={`row justify-content-center`} key={`${i}-${collection}-${i + repeterData?.length}`}>
                    <div className={`row col-xl-11`}>
                        <CardInterpreter card={card} exceptions={exceptions} collection={collection} position={i} />
                    </div>
                    <div className=" d-flex col-xl-1 justify-content-center align-items-center" >
                        <Trash className='cursor-pointer' size={14} color='red' onClick={() => dispatch(removeCollectionRegister(collection, i))} />
                    </div >
                </div>}
            </Repeater>
            <div className='d-flex' style={{ width: '60px' }}>
                <Button.Ripple size='sm' color='primary' outline={true} className='btn-icon form-control mt-1' onClick={increaseCount}>
                    <Plus size={14} />
                </Button.Ripple>
            </div>
        </>
    )
}
